
export default function Loader({ loading, children }) {
  return (
    <div className="loader-wrapper">
      <div className={`loader-content ${loading ? 'loading' : ''}`}>
        {children}
      </div>
      {loading && (
        <div className="loader-overlay">
          <div className="d-flex justify-content-center m-4">
            <div className="spinner-border align-items-center" role="status">
              <span className="sr-only"></span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}